
import Vue from 'vue';
import _ from 'lodash';

export default Vue.extend({
  name: 'CPrintPage',
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    arabicTitle: {
      type: String,
      default: ''
    },
    hideDefaultHeaders: {
      type: Boolean,
      default: false
    },
    documentDate: {
      type: String,
      default: ''
    }
  },
  data (): { companyDetails: any } {
    return {
      companyDetails: ''
    }
  },
  computed: {
    useNewDetails(): boolean {
      if (!this.documentDate) return true;
      const thresholdDate = new Date('2026-09-01T00:00:00');
      const docDate = new Date(this.documentDate);
      return docDate >= thresholdDate;
    },
    displayName(): any {
      if (!this.companyDetails) return { en: '', ar: '' };
      return this.useNewDetails && this.companyDetails.newName 
        ? this.companyDetails.newName 
        : this.companyDetails.name || { en: '', ar: '' };
    },
    displayTel(): any {
      if (!this.companyDetails) return { en: '', ar: '' };
      return this.useNewDetails && this.companyDetails.newTel 
        ? this.companyDetails.newTel 
        : this.companyDetails.tel || { en: '', ar: '' };
    }
  },
  async mounted() {
    this.setupPrint();
    if(this.$store.state.user.loggedIn) {
      this.companyDetails = _.get(this.$store, 'state.staticData[company-detail]', {});
    }
  },
  methods: {
    async setupPrint() {
      await this.$nextTick();
      if(!this.$props.content) return;
      let originalParent = this.$props.content.$el.parentNode;
      window.onbeforeprint = () => { 
        // @ts-ignore
        this.$refs.content.appendChild(this.$props.content.$el);
      };
      window.onafterprint = () => { 
        originalParent.appendChild(this.$props.content.$el);
      };
    }
  }
})
